// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsUserManagementWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsUserManagementWebApiHandler_assignApplicationManager,
  CappsUserManagementWebApiHandler_createCappsUser,
  CappsUserManagementWebApiHandler_getNames,
  CappsUserManagementWebApiHandler_getNames_Path,
  CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification,
  CappsUserManagementWebApiHandler_requestApplicationPermissions,
  CappsUserManagementWebApiHandler_setName,
  CappsUserManagementWebApiHandler_userManagementCompanyDetails,
  CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path,
} from '@zg-rentals/ts-capps-client';

import type {
  AssignApplicationManagerRequestDto,
  GetNamesRequestDto,
  GetNamesResponseDto,
  SetNameRequestDto,
  UserManagementCompanyDetailsResponseDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsUserManagementWebApiHandler_assignApplicationManager_Args {
  postData: AssignApplicationManagerRequestDto;
}

export type CappsUserManagementWebApiHandler_assignApplicationManager_Options = UseMutationOptions<
  void,
  unknown,
  CappsUserManagementWebApiHandler_assignApplicationManager_Args
>;

export const useCappsUserManagementWebApiHandler_assignApplicationManager = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_assignApplicationManager_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsUserManagementWebApiHandler_assignApplicationManager_Args) =>
      CappsUserManagementWebApiHandler_assignApplicationManager(args.postData, httpClient),
  });
};

export type CappsUserManagementWebApiHandler_createCappsUser_Options = UseMutationOptions<void, unknown, void>;

export const useCappsUserManagementWebApiHandler_createCappsUser = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_createCappsUser_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsUserManagementWebApiHandler_createCappsUser(httpClient),
  });
};

export type CappsUserManagementWebApiHandler_getNames_Options = UseQueryOptions<
  GetNamesResponseDto,
  unknown,
  GetNamesResponseDto,
  readonly [string, GetNamesRequestDto]
>;

const CappsUserManagementWebApiHandler_getNames_GetKey = (postData: GetNamesRequestDto) =>
  [CappsUserManagementWebApiHandler_getNames_Path, postData] as const;

export const CappsUserManagementWebApiHandler_getNames_queryOptions = (
  postData: GetNamesRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsUserManagementWebApiHandler_getNames_GetKey(postData),
    queryFn: () => CappsUserManagementWebApiHandler_getNames(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsUserManagementWebApiHandler_getNames = (
  postData: GetNamesRequestDto,
  {
    httpClient,
    ...options
  }: Omit<CappsUserManagementWebApiHandler_getNames_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...CappsUserManagementWebApiHandler_getNames_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useCappsUserManagementWebApiHandler_getNames.getKey = CappsUserManagementWebApiHandler_getNames_GetKey;

export type CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Options = UseMutationOptions<
  void,
  unknown,
  void
>;

export const useCappsUserManagementWebApiHandler_requestApplicationManagerIdVerification = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification(httpClient),
  });
};

export type CappsUserManagementWebApiHandler_requestApplicationPermissions_Options = UseMutationOptions<
  void,
  unknown,
  void
>;

export const useCappsUserManagementWebApiHandler_requestApplicationPermissions = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_requestApplicationPermissions_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsUserManagementWebApiHandler_requestApplicationPermissions(httpClient),
  });
};

export interface CappsUserManagementWebApiHandler_setName_Args {
  postData: SetNameRequestDto;
}

export type CappsUserManagementWebApiHandler_setName_Options = UseMutationOptions<
  void,
  unknown,
  CappsUserManagementWebApiHandler_setName_Args
>;

export const useCappsUserManagementWebApiHandler_setName = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_setName_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsUserManagementWebApiHandler_setName_Args) =>
      CappsUserManagementWebApiHandler_setName(args.postData, httpClient),
  });
};

export type CappsUserManagementWebApiHandler_userManagementCompanyDetails_Options = UseQueryOptions<
  UserManagementCompanyDetailsResponseDto,
  unknown,
  UserManagementCompanyDetailsResponseDto,
  readonly [string]
>;

const CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey = () =>
  [CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path] as const;

export const CappsUserManagementWebApiHandler_userManagementCompanyDetails_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey(),
    queryFn: () => CappsUserManagementWebApiHandler_userManagementCompanyDetails(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsUserManagementWebApiHandler_userManagementCompanyDetails = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_userManagementCompanyDetails_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsUserManagementWebApiHandler_userManagementCompanyDetails_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsUserManagementWebApiHandler_userManagementCompanyDetails.getKey =
  CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey;
